import { LoadingController } from '@ionic/angular';
import { BUSNQuoteScheduleService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import { Component, OnInit } from '@angular/core';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { SharedConfig, SharedDialogService, SharedFormulaService } from '@takectrl-multiapp/svcs-share-config';
import { ICtrlFileResponse } from 'libs/svcs-ctrl-api/src/lib/interfaces/api.interface';
declare const dataLayer: any[];

@Component({
  selector: 'useful-documents',
  standalone: false,
  templateUrl: './useful-documents.component.html',
  styleUrls: ['./useful-documents.component.scss'],
})
export class UsefulDocumentsComponent implements OnInit {
  documents: ICtrlFileResponse[] = new Array;
  loader = this.loadingController.create();
  constructor(
    public thirdpartyService: BUSNThirdPartyService,
    public sharedConfig: SharedConfig,
    private readonly busnUserService: BUSNUserService,
    private readonly loadingController: LoadingController,
    public sharedFormulaService: SharedFormulaService,
    private readonly busnQuoteSchduleService: BUSNQuoteScheduleService,
    private readonly sharedDialogService: SharedDialogService
  ) {}

  ngOnInit(): void {
    const activeInsurerProviders = SharedConfig.insurers().filter(i => i.active).map(i => i.provider);
    const onlyPremiaActive = activeInsurerProviders.length > 0 && activeInsurerProviders.every(p => p === 'premia');
    if (!onlyPremiaActive){
      this.getDocuments();
    } 

    dataLayer.push({
      event: 'page_show',
      screenPath: 'useful-documents',
      screenName: 'useful-documents',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  async getDocuments() {
    try {
      this.sharedConfig.setShowCustomLoader(true)
      this.busnUserService.getDocuments().then(async (docs) => {
        this.documents = docs;
        this.sharedConfig.setShowCustomLoader(false)
      });
    } catch (error) {
      console.log(error)
    } finally {
      this.sharedConfig.setShowCustomLoader(false)
    }
  }

  async downloadPremiaSchedule() {
    this.sharedConfig.setShowCustomLoader(true);
    try {
      const quoteScheduleFile = await this.busnQuoteSchduleService.getPremiaPolicySchedule(this.sharedConfig.schedulesActive[0].id);
      const url = URL.createObjectURL(quoteScheduleFile);
      window.open(url, '_blank');
    } catch (error) {
      this.sharedDialogService.showPopupDialog({
            header: 'Something went wrong',
            subHeader: 'We could not download the policy schedule. Please try again.',
            buttonOneText: 'OK',
            buttonOneCallback: this.sharedDialogService.hidePopupDialog,
          });
    } finally {
      this.sharedConfig.setShowCustomLoader(false);
    }
  }

  viewPDF(index: number) {
    window.open(this.documents[index].url, '_blank');
  }
}
